import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';
import Image from '../../Atoms/Image';
import Button from '../../Atoms/Button';

import Promo from '../../Organisms/Promo';
import bgMesh from '../../../assets/img/mesh_blue.png';
import Robot from '../../../assets/img/robot.png';
import CardBenefits from '../../Molecules/CardBenefits';
import StepsList from '../../Molecules/StepsList';
import CanvasSuccess from '../../Molecules/CanvasSuccess';

function SuccessPage() {
  return (
    <>
      <div className="relative z-0 bg-white pt-20 md:pt-24">
        <Promo
          bg="linear-gradient(225deg,#606af8,#5f6fff)"
          bgImg={bgMesh}
          bgPosition="bottom"
          bgSize="contain"
          fluidContainer
          className="text-white"
        >
          <div className="mx-auto flex w-full max-w-screen-2xl flex-col items-center justify-between gap-7 sm:flex-row md:gap-14 lg:px-10">
            <div className="w-full sm:w-1/2">
              <Title color="inherit" className="mb-7">
                Bedankt voor het uploaden van je CV.
              </Title>
              <Text color="inherit">
                Je sollicitatie is goed ontvangen. Dit is
                wat jij nu kunt verwachten:
              </Text>
              <div>
                <StepsList
                  theme="light"
                  steps={[
                    'Je ontvangt een bevestiging op',
                    'Ambitiegesprek',
                    'Selectie van mogelijkheden',
                    'Gesprekken bij geselecteerde werkgevers',
                    'Kiezen van jouw uitdaging!'
                  ]}
                  className="mt-7"
                />
              </div>
            </div>

            <div className="flex w-full items-center justify-center sm:w-1/2">
              <Image src={Robot} alt="Robot" />
            </div>
          </div>
        </Promo>
      </div>

      <div className="relative z-10 px-7">
        <div className="mx-auto -my-10 max-w-5xl rounded-xl bg-white p-7 shadow-2xl lg:-my-20 lg:p-14">
          <div className="flex flex-col items-center justify-between gap-7 text-center md:flex-row md:text-left">
            <Title as="h2" size={4}>
              Deel jouw nieuwe stap via Social Media
            </Title>
            <div className="flex gap-3.5">
              <Button
                iconName="whatsapp"
                fullRounded
                shadow
                color="green-wa"
                size="lg"
              />
              <Button
                iconName="facebook"
                fullRounded
                shadow
                color="blue-fb"
                size="lg"
              />
              <Button
                iconName="linkedin"
                fullRounded
                shadow
                color="blue-in"
                size="lg"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="relative z-0 bg-white py-12">
        <div className="relative z-20 mx-auto w-full max-w-7xl px-7">
          <div className="mt-10 grid w-full grid-cols-1 gap-7 lg:mt-40 lg:grid-cols-3 lg:gap-3">
            <CardBenefits
              title="De beste volgende stap"
              text="Met een brede keuze uit banen kiezen we met elkaar de carrièrestap waarmee je bouwt aan jouw toekomst."
              icon="rocket-regular"
            />
            <CardBenefits
              title="Altijd vaste banen"
              text="Echt bouwen aan jouw carrière doe je door te investeren in je toekomst met een vaste baan."
              icon="file-contract-regular"
            />
            <CardBenefits
              title="Werken met specialisten"
              text="Bij Synsel Techniek verstaan we jouw technische vak. We kennen de markt, spreken jouw taal en weten wat er speelt."
              icon="lock-keyhole-regular"
            />
          </div>
        </div>
      </div>
      <CanvasSuccess />
    </>
  );
}

export default SuccessPage;
